import * as React from "react";
import { IServiceStatus } from "@nju/data-access-portal-product";

export const MemberServiceStatusContext = React.createContext<IServiceStatus>({
  ftthServiceStatus: undefined,
  mobileServiceStatus: undefined,
  fSecureServiceStatus: undefined,
});

export function useMemberServiceStatus() {
  const value = React.useContext(MemberServiceStatusContext);

  if (value === null) {
    throw new Error("`Missing ServiceStatusContext` in tree.");
  }

  return value;
}
